// Ensure Ctrl+Shift+[key] is not used by the browser 
export const problemHashTagHotkeys = [
    `1`,
    `2`,
    `3`,
    `4`,
    `f`,
    `x`,
    `v`,
    `5`,
    `6`,
    `7`,
    `8`,
    `9`,
];

export const GetProblemHashTagHotkeyLabel = (index: number) =>
    problemHashTagHotkeys[index] ?? index.toString();
